import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
Vue.use(Router)

import layout from '../views/layout/layout'

// export const constantRouterMap =

const router = new Router({
  routes: [
    {
      path: '/',
      component: layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/home'),
          meta: {
            title: '中原e购-首页',
          },
        },
        {
          path: 'procurementCenter',
          name: 'procurementCenter',
          component: () => import('@/views/procurementCenter'),
          meta: {
            title: '采购中心',
            needLogin: true,
          },
        },
        {
          path: '/evaluate',
          name: 'evaluate',
          component: () => import('@/views/procurementCenter/evaluate'),
          meta: {
            title: '我的评价',
            needLogin: true,
          },
        },
        {
          path: '/applyorder',
          name: 'applyorder',
          component: () => import('@/views/procurementCenter/applyorder/index'),
          meta: {
            title: '请购单管理',
            needLogin: true,
          },
        },
        {
          path: 'purchaseList',
          name: 'purchaseList',
          component: () => import('@/views/purchaseList/index'),
          meta: {
            title: '我的购物车',
            needLogin: true,
          },
        },
        {
          path: 'recommend',
          name: 'recommend',
          component: () => import('@/views/recommend/index'),
          meta: {
            title: '商品推荐',
            needLogin: true,
          },
        },
        {
          path: 'buyList',
          name: 'buyList',
          component: () => import('@/views/buyList/index'),
          meta: {
            title: '采购计划',
            needLogin: true,
          },
        },
        {
          //2021-05-26 18:40 刘敏
          path: '/applyorderdetail',
          name: 'applyorderdetail',
          component: () =>
            import('@/views/procurementCenter/applyorder/detail'),
          meta: {
            title: '请购单详情',
            needLogin: true,
          },
        },
        {
          //2021-05-31 10:40 刘敏
          path: '/approval',
          name: 'approval',
          component: () =>
            import('@/views/procurementCenter/applyorder/approval'),
          meta: {
            title: '请购单审批',
            needLogin: true,
          },
        },
        {
          //2021-05-31 10:40 刘敏
          path: '/approvaldetail',
          name: 'approvaldetail',
          component: () =>
            import('@/views/procurementCenter/applyorder/approvaldetail'),
          meta: {
            title: '请购单详情',
            needLogin: true,
          },
        },
        {
          //2021-06-02 10：00 lmx
          path: '/approvaledit',
          name: 'approvaledit',
          component: () =>
            import('@/views/procurementCenter/applyorder/approvaledit'),
          meta: {
            title: '请购单修改',
            needLogin: true,
          },
        },
        {
          //2021-05-24 14:29 刘敏
          path: '/orderList',
          name: 'orderList',
          component: () => import('@/views/procurementCenter/order/orderList'),
          meta: {
            title: '订单列表',
            needLogin: true,
          },
        },
        {
          //2021-05-24 14:29 刘敏
          path: '/orderquiry',
          name: 'orderquiry',
          component: () =>
            import('@/views/procurementCenter/dataquery/orderquiry'),
          meta: {
            title: '订单查询-采购中心',
            needLogin: true,
          },
        },
        {
          //2021-07-10 14:29 刘敏
          path: '/ordersearch',
          name: 'ordersearch',
          component: () =>
            import('@/views/procurementCenter/dataquery/ordersearch'),
          meta: {
            title: '订单查询-采购中心',
            needLogin: true,
          },
        },
        {
          //2021-07-10 14:29 刘敏
          path: '/purchasegood',
          name: 'purchasegood',
          component: () =>
            import('@/views/procurementCenter/dataquery/purchasegood'),
          meta: {
            title: '采购商品表-采购中心',
            needLogin: true,
          },
        },
        {
          //2021-05-26 18:40 刘敏
          path: '/orderdetail',
          name: 'orderdetail',
          component: () => import('@/views/procurementCenter/order/detail'),
          meta: {
            title: '订单详情',
            needLogin: true,
          },
        },
        {
          //2021-05-24 19:38 刘敏
          path: '/settingindex',
          name: 'settingindex',
          component: () => import('@/views/procurementCenter/setting/index'),
          meta: {
            title: '个人中心',
            needLogin: true,
          },
        },
        {
          //2021-05-25 刘敏
          path: '/address',
          name: 'address',
          component: () => import('@/views/procurementCenter/address/index'),
          meta: {
            title: '收货地址',
            needLogin: true,
          },
        },
        {
          //2021-05-25 刘敏
          path: '/mycollect',
          name: 'mycollect',
          component: () => import('@/views/procurementCenter/mycollect/index'),
          meta: {
            title: '我的收藏',
            needLogin: true,
          },
        },
        {
          //2021-05-26 刘敏
          path: '/train',
          name: 'train',
          component: () => import('@/views/procurementCenter/train/index'),
          meta: {
            title: '培训资料',
            needLogin: true,
          },
        },
        {
          //2021-05-26 刘敏
          path: '/orderreturn',
          name: 'orderreturn',
          component: () =>
            import('@/views/procurementCenter/orderreturn/index'),
          meta: {
            title: '退换货订单',
            needLogin: true,
          },
        },
        {
          //2021-05-26 刘敏
          path: '/secondApply',
          name: 'secondApply',
          component: () =>
            import('@/views/procurementCenter/orderreturn/secondApply'),
          meta: {
            title: '再次申请退货-采购中心',
            needLogin: true,
          },
        },
        {
          //2021-05-26 刘敏
          path: '/secondApply2',
          name: 'secondApply2',
          component: () =>
            import('@/views/procurementCenter/orderreturn/secondApply2'),
          meta: {
            title: '退换货管理-采购中心',
            needLogin: true,
          },
        },
        {
          //2021-05-26 18:40 刘敏
          path: 'orderreturndetail',
          name: 'orderreturndetail',
          component: () =>
            import('@/views/procurementCenter/orderreturn/detail'),
          meta: {
            title: '退换货订单详情',
            needLogin: true,
          },
        },
        {
          //2021-05-26 刘敏
          path: 'aboutus',
          name: 'aboutus',
          component: () => import('@/views/help/index'),
          meta: {
            title: '关于我们',
          },
        },
        {
          path: 'goodsList',
          name: 'goodsList',
          component: () => import('@/views/goods/goodsList'),
          meta: {
            title: '商品搜索',
          },
        },
        {
          path: 'goodsDetail',
          name: 'goodsDetail',
          component: () => import('@/views/goods/goodsDetail'),
          meta: {
            title: '商品详情',
          },
        },
        {
          path: '/supermarket',
          name: 'supermarket',
          component: () => import('@/views/supermarket/index'),
          meta: { title: 'e购超市' },
        },
        {
          path: '/powerregion',
          name: 'powerregion',
          component: () => import('@/views/powerregion/index'),
          meta: { title: '电力专区' },
        },
        {
          path: '/wellness',
          name: 'wellness',
          component: () => import('@/views/wellness/index'),
          meta: { title: '康养专区' },
        },
        {
          path: '/zone',
          name: 'zone',
          component: () => import('@/views/zone/index'),
          meta: { title: '专区' },
        },
        {
          path: '/sunshop',
          name: 'sunshop',
          component: () => import('@/views/sunshop/index'),
          meta: { title: '阳光销售' },
        },
        {
          path: '/sundetail',
          name: 'sundetail',
          component: () => import('@/views/sunshop/detail'),
          meta: { title: '阳光销售详情' },
        },
        {
          path: '/helpbefriend',
          name: 'helpbefriend',
          //参照劳保专区做的页面
          //component: () => import('@/views/helpbefriend/help'),
          //不是完全从后台获取的
          //component: () => import('@/views/helpbefriend/index'),
          //不是完全从后台获取的 但是商品从后台获取
          component: () => import('@/views/helpbefriend/indexhelp'),
          meta: { title: '精准帮扶' },
        },
        {
          path: '/staffshop',
          name: 'staffshop',
          component: () => import('@/views/staffshop/index'),
          meta: { title: '员工商城' },
        },
        {
          path: '/home/smartwin',
          name: 'smartwin',
          component: () => import('@/views/home/smartwin/smartwin'),
          meta: { title: 'e购智营' },
        },
        {
          path: '/home/citydevelopment',
          name: 'citydevelopment',
          component: () =>
            import('@/views/home/citydevelopment/citydevelopment'),
          meta: { title: '城发环保专区' },
        },
        {
          path: '/building',
          name: 'building',
          component: () => import('@/views/building/building'),
          meta: { title: '正在建设中' },
        },
        {
          path: '/home/group',
          name: 'group',
          component: () => import('@/views/home/group/group'),
          meta: { title: '集团专区' },
        },
        {
          path: '/help/platformlogin',
          name: 'platformlogin',
          component: () => import('@/views/help/goodspurchase/platformlogin'),
          meta: { title: '平台登陆' },
        },
        {
          path: '/help/searchbrowsing',
          name: 'searchbrowsing',
          component: () => import('@/views/help/goodspurchase/searchbrowsing'),
          meta: { title: '商品搜索和浏览' },
        },
        {
          path: '/help/goodsorder',
          name: 'goodsorder',
          component: () => import('@/views/help/goodspurchase/goodsorder'),
          meta: { title: '商品下单' },
        },
        {
          path: '/help/orderapproval',
          name: 'orderapproval',
          component: () => import('@/views/help/goodspurchase/orderapproval'),
          meta: { title: '请购单审批' },
        },
        {
          path: '/help/seeorder',
          name: 'seeorder',
          component: () => import('@/views/help/goodspurchase/seeorder'),
          meta: { title: '查看订单' },
        },
        {
          path: '/help/logisticsquery',
          name: 'logisticsquery',
          component: () => import('@/views/help/goodspurchase/logisticsquery'),
          meta: { title: '物流查询' },
        },
        {
          path: '/help/orderfailed',
          name: 'orderfailed',
          component: () => import('@/views/help/goodspurchase/orderfailed'),
          meta: { title: '下单失败' },
        },
        {
          path: '/help/confirmreceipt',
          name: 'confirmreceipt',
          component: () => import('@/views/help/goodspurchase/confirmreceipt'),
          meta: { title: '确认收货' },
        },
        {
          path: '/help/logcheck',
          name: 'logcheck',
          component: () => import('@/views/help/commoditycheck/logcheck'),
          meta: { title: '登录对账平台' },
        },
        {
          path: '/help/goodsseek',
          name: 'goodsseek',
          component: () => import('@/views/help/goodsseek/goodsseek'),
          meta: { title: '商品寻源' },
        },
        {
          path: '/help/problem',
          name: 'problem',
          component: () => import('@/views/help/problem/problem'),
          meta: { title: '常见问题' },
        },
        {
          path: '/help/errfeedback',
          name: 'errfeedback',
          component: () => import('@/views/help/commoditycheck/errfeedback'),
          meta: { title: '对账内容错误反馈' },
        },
        {
          path: '/help/step',
          name: 'step',
          component: () => import('@/views/help/commoditycheck/step'),
          meta: { title: '每月对账步骤' },
        },
        {
          path: '/help/invoice',
          name: 'invoice',
          component: () => import('@/views/help/commoditycheck/invoice'),
          meta: { title: '发票页' },
        },
        {
          path: '/help/reportform',
          name: 'reportform',
          component: () => import('@/views/help/commoditycheck/reportform'),
          meta: { title: '生成对账报表' },
        },
        {
          //2021-12-29 刘敏
          path: '/help/index',
          name: 'announce',
          component: () => import('@/views/help/notice/index'),
          meta: {
            title: '帮助中心-栏目',
          },
        },
        {
          path: '/help/notice',
          name: 'notice',
          component: () => import('@/views/help/notice/notice'),
          meta: { title: '公告详情' },
        },
        {
          path: '/goods/goodsRequisition',
          name: 'goodsRequisition',
          component: () => import('@/views/goods/goodsRequisition'),
          meta: { title: '商品请购单管理' },
        },
        {
          path: '/orderlist/aymentdetail',
          name: 'aymentdetail',
          component: () =>
            import('@/views/procurementCenter/order/aymentdetail'),
          meta: { title: '付款单详情' },
        },
        {
          path: '/orderlist/complaintdetail',
          name: 'complaintdetail',
          component: () =>
            import('@/views/procurementCenter/order/complaintdetail'),
          meta: { title: '投诉详情' },
        },
        {
          path: '/goods/submitsuccess',
          name: 'submitsuccess',
          component: () => import('@/views/goods/submitsuccess'),
          meta: { title: '提交请购单-提交成功' },
        },
        {
          path: '/orderlist/returngoods',
          name: 'returngoods',
          component: () =>
            import('@/views/procurementCenter/order/returngoods'),
          meta: { title: '订单管理-退货申请' },
        },
        {
          path: '/orderlist/changegoods',
          name: 'changegoods',
          component: () =>
            import('@/views/procurementCenter/order/changegoods'),
          meta: { title: '提交请购单-换货申请' },
        },
        {
          path: '/dataquery/applyorderquery',
          name: 'applyorderquery',
          component: () =>
            import('@/views/procurementCenter/dataquery/applyorderquery'),
          meta: { title: '数据查询-请购单查询' },
        },
        {
          path: '/shoplist',
          name: 'shoplist',
          component: () => import('@/views/goods/shop/shoplist'),
          meta: { title: '店铺列表' },
        },
        // 场景化购买
        {
          path: '/scenehome',
          name: 'scenehome',
          component: () => import('@/views/scenebuy/scenelist'),
          meta: { title: '场景化购买' },
        },
        // 商品比价
        {
          path: '/goodspk',
          name: 'goodspk',
          component: () => import('@/views/goodspk/index'),
          meta: { title: '商品比价' },
        },
        // 自营搜索列表页
        {
          path: '/proprietaryGoods',
          name: 'proprietaryGoods',
          component: () => import('@/views/goods/proprietaryGoods'),
          meta: { title: '商品搜索' },
        },
        {
          path: '/userdata',
          name: 'userdata',//这个具体的采购人
          component: () =>
            import('@/views/procurementCenter/dataquery/userdata'),
          meta: { title: '用户画像', needLogin: true },
        },
        {
          path: '/portrait',
          name: 'portrait',//这个是审批人，可以选择具体的采购人
          component: () =>
            import('@/views/procurementCenter/dataquery/portrait'),
          meta: { title: '企业画像', needLogin: true },
        },
        {
          path: '/goodsdata',
          name: 'goodsdata',
          component: () =>
            import('@/views/procurementCenter/dataquery/goodsdata'),
          meta: { title: '商品画像', needLogin: true },
        },
        {
          path: '/goodsdata/goodsdatadetail',
          name: 'goodsdatadetail',
          component: () =>
            import('@/views/procurementCenter/dataquery/goodsdatadetail'),
          meta: { title: '商品画像详情', needLogin: true },
        },
        {
          path: '/supplierList',
          name: 'supplierlist',
          component: () => import('@/views/supplierList/index'),
          meta: { title: '合格供应商' },
        },
        {
          path: '/platform',
          name: 'platform',
          component: () => import('@/views/help/platform'),
          meta: { title: '如何入驻平台' },
        },
      ],
    },
    {
      path: '/403',
      name: 'nopermission',
      component: () => import('@/views/error/nopermission'),
      meta: { title: '403' },
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/error/test'),
      meta: { title: '测试' },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/login'),
      meta: { title: '登录' },
    },
    {
      path: '/revisePwd',
      name: 'revisePwd',
      component: () => import('@/views/login/revisePwd'),
      meta: { title: '修改密码' },
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('@/views/goods/shop/shop'),
      meta: { title: '店铺' },
    },
    {
      path: '/applyorder/printing',
      name: 'printing',
      component: () => import('@/views/procurementCenter/applyorder/printing'),
      meta: { title: '打印请购单' },
    },
    {
      path: '/online',
      name: 'online',
      component: () => import('@/views/online/index'),
      meta: { title: '在线客服' },
    },
    {
      path: '/adminonline',
      name: 'adminonline',
      component: () => import('@/views/online/admin'),
      meta: { title: '在线客服' },
    },
  ],
})

const originalPush = Router.prototype.push

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

router.beforeEach(async (to, from, next) => {
  let { title, needLogin } = to.meta
  const { success } = await store.dispatch('getLoginStatus')
  // 从vuex获取登录状态
  //let isLogin = store.state.login_status;
  let isLogin = success
  document.title = title
  if (needLogin && !isLogin) {
    let wsmemberId = jsCookie.get('wsmemberId')
    if (wsmemberId.indexOf('customer') == -1) {
      //表示上一用户是登录用户，不是登录用户就是游客 
      //游客里面wsmemberId  含有customer后缀
      store.commit('changeWsMemberId', '')
      jsCookie.set('wsmemberId', '')
      store.commit('changeLogin', 0)
      store.commit('changeLogintwo', { Authorization: '' })
      //清除比价数据
      localStorage.removeItem('contrastgoods')
      if (localStorage.getItem('shenpiliu')) {
        localStorage.removeItem('shenpiliu')
      } //清除是否打开在线客服 弹出框
      localStorage.removeItem('onlineDialog')
      store.commit('changeIsMessage', 0)
    }
    next({
      path: '/login',
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js